/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import Sidebar from "../../../components/AdminComponents/SideNav";
import EditableImage from "../../../components/icons/EditIcon";
// import { useDispatch } from "react-redux";
// import { setData } from "../../../store/slices/ModuleData";
import { Table, Image, Spin, Pagination } from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { ClientMenu } from "../../../components/AdminComponents/MenuItems";
import Axios from "../../../api/Axios";
import {
  capitalizeWords,
  remainingViewportHeight,
} from "../../../components/icons/ApplicationColor";
import { useSelector } from "react-redux";
import { getUpdateStatus1 } from "../../../components/AdminComponents/ViewUpdateIndexTnAdmin";
import CommonTopDetails from "../../../components/AdminComponents/CommonTopDetails";

const Modules = () => {
  // const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [itemsLength, setItemsLength] = useState();
  const userInfo = useSelector((state) => state.user);
  const updateAuth = getUpdateStatus1(userInfo, 1, 0);
  const [filterData, setFilterData] = useState({
    pageSize: 15,
    currentPage: 1,
    url: `/applicationlist/`,
    search: "",
  });
  const { pageSize, currentPage, url, search } = filterData;
  const LoadUser = async () => {
    let passUrl = url;
    let doNothing = false;
    if (search?.length > 0) {
      if (search.length > 1) {
        passUrl += `?page=${currentPage}&page_size=${pageSize}&search=${search}`;
      } else {
        doNothing = true;
      }
    } else {
      passUrl += `?page=${currentPage}&page_size=${pageSize}`;
    }
    if (!doNothing) {
      setLoading(true);
      try {
        const res = await Axios.get(passUrl);
        setData(res.data.results);
        setItemsLength(res.data.count);
        setLoading(false);
        //console.log(data);
      } catch (err) {
        //console.log(err);
      }
    }
  };
  const onShowSizeChange = (current, size) => {
    setFilterData((prevData) => ({
      ...prevData,
      pageSize: size,
    }));
  };

  const onPageChange = (page, pageSize) => {
    setFilterData((prevData) => ({
      ...prevData,
      currentPage: page,
    }));
  };
  const handleSearchChange = (event) => {
    setFilterData((prevData) => ({
      ...prevData,
      search: event.target.value,
      currentPage: 1,
    }));
  };
  useEffect(() => {
    LoadUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData]);

  const renderStatus = (text, record) => {
    if (record.status) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "1.8rem",
              height: "1.8rem",
              borderRadius: "50%",
              backgroundColor: "#52c41a",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CheckOutlined
              style={{ color: "#fff", fontSize: "1.2rem", fontWeight: "700" }}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "1.8rem",
              height: "1.8rem",
              borderRadius: "50%",
              backgroundColor: "#ff4d4f",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CloseOutlined
              style={{ color: "#fff", fontSize: "1rem", fontWeight: "600" }}
            />
          </div>
        </div>
      );
    }
    // else {
    //   return text;
    // }
  };
  const columns = [
    {
      title: capitalizeWords("module id"),
      dataIndex: "app_id",
      key: "app_id",
    },
    {
      title: capitalizeWords("module logo"),
      dataIndex: "logo",
      key: "logo",
      render: (logo) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Image src={logo} width={100} />
        </div>
      ),
    },
    {
      title: capitalizeWords("module name"),
      dataIndex: "name",
      key: "name",
    },
    {
      title: capitalizeWords("module type"),
      dataIndex: "type",
      key: "type",
    },
    {
      title: capitalizeWords("category"),
      dataIndex: "category",
      key: "category",
    },
    {
      title: capitalizeWords("clients"),
      dataIndex: "clients",
      key: "clients",
    },
    {
      title: capitalizeWords("status"),
      dataIndex: "status",
      key: "status",
      render: renderStatus,
      align: "center",
    },
    ...(updateAuth
      ? [
          {
            title: capitalizeWords("actions"),
            dataIndex: "actions",
            key: "actions",
            align: "center",
            render: (text, record) => (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <EditableImage
                  handleRowClick={handleRowClick}
                  recordId={record.id}
                />
              </div>
            ),
          },
        ]
      : []),
  ];

  // useEffect(() => {
  //   // Store the data in the Redux store when the component mounts
  //   dispatch(setData(data));
  // }, [data, dispatch]);

  const history = useNavigate();
  const handleRowClick = (record) => {
    //console.log(record);
    history(`/admin-manager/modules/details/${record}`);
  };
  return (
    <div>
      <Sidebar props={ClientMenu}>
        <CommonTopDetails
          title="Module Summary"
          titleSuffix={`${itemsLength || 0} modules(s)`}
          searchPlaceholder="Search by..."
          searchAction={handleSearchChange}
          showAddButton={updateAuth}
          addButtonProps={{
            modalType: "Redirect",
            redirctlink: "/admin-manager/modules/add-user",
          }}
        />
        <div className="form-container">
          <Spin spinning={loading}>
            <Table
              columns={columns}
              dataSource={data}
              size="small"
              rowKey="id"
              bordered
              scroll={{
                x: 1000,
                y: `${remainingViewportHeight(24)}px`,
              }}
              pagination={false}
              className="table-container"
              style={{ margin: "1rem" }}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "1rem",
              }}
            >
              <Pagination
                size="small"
                showSizeChanger
                onShowSizeChange={onShowSizeChange}
                onChange={onPageChange}
                pageSizeOptions={["10", "15", "30", "50", "100"]}
                showQuickJumper
                current={currentPage}
                defaultPageSize={pageSize}
                total={itemsLength}
              />
            </div>
          </Spin>
        </div>
      </Sidebar>
    </div>
  );
};

export default Modules;
